var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNightSleep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.866,
    height: 38.654,
    viewBox: "0 0 42.866 38.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1181",
    "data-name": "Grupo 1181",
    transform: "translate(-524.016 -453.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1070",
    "data-name": "Grupo 1070",
    transform: "translate(1958.335 7986.4) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7310",
    "data-name": "Trazado 7310",
    d: "M2530.049-7214.881a11.5,11.5,0,0,1,11.5-11.5c.04,0,.078,0,.119.005a14.138,14.138,0,0,0-8.353-2.728,14.222,14.222,0,0,0-14.223,14.223,14.223,14.223,0,0,0,14.223,14.223,14.142,14.142,0,0,0,8.353-2.728c-.041,0-.079.005-.119.005A11.5,11.5,0,0,1,2530.049-7214.881Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7311",
    "data-name": "Trazado 7311",
    d: "M2539.631-7205.708",
    transform: "translate(2.038 2.321)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7312",
    "data-name": "Trazado 7312",
    d: "M2539.631-7226.622",
    transform: "translate(2.038 0.246)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7313",
    "data-name": "Trazado 7313",
    d: "M2540.68-7226.621c-.041,0-.079-.005-.119-.005a11.5,11.5,0,0,0-11.5,11.5,11.5,11.5,0,0,0,11.5,11.5c.04,0,.078-.005.119-.005",
    transform: "translate(0.989 0.245)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1073",
    "data-name": "Grupo 1073",
    transform: "translate(-1868.991 7740.765)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_345",
    "data-name": "L\\xEDnea 345",
    x2: 5.547,
    transform: "translate(2421.991 -7283.314)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_346",
    "data-name": "L\\xEDnea 346",
    x2: 5.547,
    transform: "translate(2421.991 -7276.462)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_347",
    "data-name": "L\\xEDnea 347",
    x1: 5.547,
    y2: 6.852,
    transform: "translate(2421.991 -7283.314)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_348",
    "data-name": "L\\xEDnea 348",
    x2: 3.445,
    transform: "translate(2431.021 -7285.442)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_349",
    "data-name": "L\\xEDnea 349",
    x2: 3.445,
    transform: "translate(2431.021 -7281.187)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_350",
    "data-name": "L\\xEDnea 350",
    x1: 3.445,
    y2: 4.255,
    transform: "translate(2431.021 -7285.442)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightSleep);
export default __webpack_public_path__ + "static/media/nightSleep.4e28a77d.svg";
export { ForwardRef as ReactComponent };